<template>
  <section class="py-6 md:py-12">
    <div class="max-w-screen-2xl mx-auto px-4">
      <h2 class="font-secondary text-2xl md:text-3xl mb-8">
        {{ tr('FAQs') }}
      </h2>
      <div class="mt-6 md:mt-8 w-full">
        <div
          v-for="(item, index) in items"
          :key="item.id"
          class="border-b border-t border-gray-200"
        >
          <h2 :id="'faq-heading-group-' + item.id">
            <button
              type="button"
              class="flex items-center bg-white justify-between w-full px-5 py-4 font-medium text-dark gap-3"
              @click="toggle(index)"
              :class="{ 'text-primary': activeIndex === index }"
              :aria-expanded="activeIndex === index"
              :aria-controls="'faq-body-group-' + item.id"
            >
              <span class="text-lg hover:text-primary font-bold">{{ item.title }}</span>
              <svg
                :class="{ 'rotate-180': activeIndex === index }"
                class="w-3 h-3 shrink-0"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
              </svg>
            </button>
          </h2>
          <div
            :id="'faq-body-group-' + item.id"
            :class="{ 'hidden': activeIndex !== index }"
            v-show="activeIndex === index"
          >
            <div class="p-5 pt-0 text-dark leading-tight">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FAQsGroup',
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    tr(key) {
      return this.$root.tr(key);
    }
  },
  data() {
    return {
      activeIndex: null,
      items: [
        { id: 1, title: this.tr('_FAQsGroup1'), content: this.tr('_FAQsGroupAnswer1') },
        { id: 2, title: this.tr('_FAQsGroup2'), content: this.tr('_FAQsGroupAnswer2') },
        { id: 3, title: this.tr('_FAQsGroup3'), content: this.tr('_FAQsGroupAnswer3') },
        { id: 4, title: this.tr('_FAQsGroup4'), content: this.tr('_FAQsGroupAnswer4') },
      ]
    };
  },
}
</script>
